/**
 * This module provides a collection of common style definitions for the portal application
 */

import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(({ spacing }) => ({
  // eslint-disable-next-line tss-unused-classes/unused-classes
  accordion: {
    '.MuiAccordionSummary-content > div': {
      minWidth: spacing(4),
      '@media (max-width:800px)': {
        minWidth: spacing(1),
      },
    },
    display: 'flex',
    gap: spacing(2),
    flexDirection: 'column',
  },
}))

export default useStyles
